export default __webpack_public_path__ + "static/media/bb3.2.97e1acd2.png";